import { Box, Card, CardContent, IconButton, Modal, Typography } from "@mui/material"
import CloseIcon from '@mui/icons-material/Close'

const ModalPreviewImage = ({ image, setImage,isMobile }) => {
    const base64 = image.base64 ? image.base64 : `data:${image.fileType};base64,${image.fileContent}`
    console.log('base64 ', base64)
    return (
        <Modal open={!!image} sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
            <Card sx={{ height:  '80%', width: !isMobile ? '60%' : '100%' }}>
                <Box
                    sx={{
                        p:4,
                        height:'5%',
                        display: 'flex',
                        flexDirection: 'row',
                        borderBottom: '1px solid black',
                        justifyContent: 'space-between',
                        alignItems: 'center',
                    }}
                >
                    <Typography sx={{ flex: 1 }} variant="h6">
                        {image.title}
                    </Typography>
                    <Box sx={{ display: 'flex', gap: 1 }}>
                        <IconButton onClick={() => setImage(null)} color="primary">
                            <CloseIcon />
                        </IconButton>
                    </Box>
                </Box>
                <CardContent sx={{display:'flex',justifyContent:'center',alignItems:'center',height:'95%'}}>
                    <img src={base64} width={'80%'} height={'80%'} style={{objectFit:'contain'}}></img>
                </CardContent>
            </Card>
        </Modal>
    )
}
export default ModalPreviewImage